export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.068 6.359a.491.491 0 00-.018-.689l-.343-.328a.49.49 0 00-.7.02l-3.072 3.3-2.928-3.273h-.001a.494.494 0 00-.698-.033l-.351.326h-.001a.492.492 0 00-.03.689l3.26 3.635c.188.21.456.328.732.333h.004c.276 0 .545-.114.736-.32l3.41-3.66zm-.915-.862a.29.29 0 01.415-.01l.343.327-.342-.328a.29.29 0 00-.416.011l-3.22 3.461 3.22-3.46zm-6.295.026a.294.294 0 00-.416-.019l-.35.325.35-.324a.294.294 0 01.416.018z\" fill=\"#6161FF\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};